var GoalActionMapModel = /** @class */ (function () {
    function GoalActionMapModel(goalName, occupied, actions, rowIds) {
        this.goalName = goalName;
        this.occupied = occupied;
        this.actions = actions;
        this.rowIds = rowIds;
    }
    return GoalActionMapModel;
}());
export default GoalActionMapModel;
